import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Levels } from './components/Levels';
import { Scaffolding } from './components/Scaffolding';
import { Difference } from './components/Difference';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-bone" data-id="element-0" data-mp="2wj8g1vvmd07v">
      <MetaPixel data-id="element-1" data-mp="2wi5m1f302hnq" />
      <CountdownBar data-id="element-2" data-mp="28u5z6q8t7bef" />
      <main data-id="element-3" data-mp="28te198rqp1kz">
        <Hero data-id="element-4" data-mp="28t4l0cwhy8sh" />
        <Marquee data-id="element-5" data-mp="28sl3uyeo7ofi" />
        <Levels data-id="element-6" data-mp="28s2x37udtrtc" />
        <Scaffolding data-id="element-7" data-mp="23vkw8j26adma" />
        <Difference data-id="element-8" data-mp="23w4drynwuzzs" />
        <WhatsInside data-id="element-9" data-mp="23ujho4ly78zt" />
        <InsidePages data-id="element-10" data-mp="23t8i6gzjcnei" />
        <Bonuses data-id="element-11" data-mp="3ijxokogyjwiu" />
        <Offer data-id="element-12" data-mp="3ikh98cxzsz0k" />
        <Guarantee data-id="element-13" data-mp="3iiwf2oflbi38" />
        <Faq data-id="element-14" data-mp="3ijfu9xduvsdk" />
      </main>
      <Footer data-id="element-15" data-mp="3ii4ro0w5cqo1" />
    </div>;
}